import * as React from "react";

function SvgTextMining(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.size}
      height={props.size}
      viewBox="0 0 32 32"
      style={{
        msTransform: "rotate(360deg)",
        WebkitTransform: "rotate(360deg)",
      }}
      transform="rotate(360)"
      {...props}
    >
      <path d="M18 28h8v2h-8zM18 24h12v2H18zM18 20h12v2H18z" fill="#A0A0A0" />
      <path
        d="M16.001 26.473H16L4.284 12.955 9.5 6h13l5.216 6.955-3.24 3.737 1.513 1.31 4.295-4.957L23.5 4h-15l-6.784 9.045 12.772 14.737 1.513-1.309z"
        fill="#626262"
      />
      <path fill="rgba(0, 0, 0, 0)" d="M0 0h32v32H0z" />
    </svg>
  );
}

export default SvgTextMining;
